import { SVGProps } from "react";

const Edit = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={21}
    height={20}
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.55 3.00002L4.70829 10.2417C4.44996 10.5167 4.19996 11.0584 4.14996 11.4334L3.84162 14.1333C3.73329 15.1083 4.43329 15.775 5.39996 15.6084L8.08329 15.15C8.45829 15.0834 8.98329 14.8084 9.24162 14.525L16.0833 7.28335C17.2666 6.03335 17.8 4.60835 15.9583 2.86668C14.125 1.14168 12.7333 1.75002 11.55 3.00002Z"
      stroke="currentColor"
      strokeWidth={1.4}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.4084 4.2085C10.7668 6.5085 12.6334 8.26683 14.9501 8.50016"
      stroke="currentColor"
      strokeWidth={1.4}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 18.3335H18"
      stroke="currentColor"
      strokeWidth={1.4}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Edit;
